import { Box, Paper, styled, Typography } from "@mui/material";
import { ClimateRiskLevel } from "types/types";

interface Props {
  climateRiskLevels: ClimateRiskLevel[];
}

export function ClimateRiskLegend(props: Props) {
  const { climateRiskLevels } = props;

  return (
    <StyledPaper elevation={0}>
      {climateRiskLevels.map((level, i) => (
        <Typography key={`legend-item-${level.color}-${i}`}>
          <Box
            component="i"
            sx={{
              backgroundColor: level.color,
              width: "30px",
              height: "10px",
              display: "inline-block",
              margin: "0 5px 0 0",
            }}
          />
          {level.name}
        </Typography>
      ))}
    </StyledPaper>
  );
}
const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-wrap: wrap;
`;
